import { Route } from '@angular/router';
import { SecureRouteData } from '../security/security-guard.service';

export interface ApiAuthRoute<D = any> extends Route {
  data?: SecureRouteData & D;
  children?: ApiAuthRoute<D>[];
}
